import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const nonLoggedInSlice = createSlice({
  name: "notLoggedIn",
  initialState: {
    isDrawerOpen: false,
    contextText: "",
  } as {
    isDrawerOpen: boolean;
    contextText: string;
  },
  reducers: {
    openDrawer: (
      state,
      {
        payload: { contextText = "" },
      }: PayloadAction<{
        contextText: string;
      }>
    ) => {
      state.isDrawerOpen = true;
      state.contextText = contextText;
    },
    closeDrawer: (state) => {
      state.isDrawerOpen = false;
    },
  },
});

export const { openDrawer, closeDrawer } = nonLoggedInSlice.actions;

export default nonLoggedInSlice.reducer;
